import React, {useEffect} from 'react';
import {scrollByHash} from 'app/utils';
import {inject} from 'mobx-react';
import {observer} from 'mobx-react-lite';
import SmartLoader from 'app/components/reusable/SmartLoader';
import {UserBonusesStore} from 'app/store/UserBonusesStore';
import FreespinsContent from 'app/components/my_profile/freespins/FreespinsContent';

interface MyFreeSpinsPageInterface {
    userBonusesStore?: UserBonusesStore
}

const MyFreeSpinsPage: React.FC<MyFreeSpinsPageInterface> = props => {
    useEffect(() => {
        scrollByHash();
    }, []);

    const {userBonusesStore: {bonusesLoading, bonusDataLoading}} = props;

    return <>
        {bonusDataLoading || bonusesLoading
            ? <SmartLoader/>
            : <div className="freespins profile-tab">
                <FreespinsContent/>
            </div>}
    </>;
};

export default inject('userBonusesStore')(observer(MyFreeSpinsPage));
